var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Live = OCS.Viewer.Live || {};
OCS.Viewer.Live.DataRequest = OCS.Viewer.Live.DataRequest || {};
OCS.Viewer.Classes.AbstractDataRequest = new Class({
    Implements: [Options, Events, new Class(OCS.Interfaces.UniqueId)],
    class_type: "DataRequest",
    class_name: "AbstractDataRequest",
    state: 0,
    retries: 0,
    options: {
        states: ["Inactive", "Active - Waiting for data", "Active - Initial data recieved", "Complete"],
        metadata: {
            dataset: '',
            variables: [],
            grid: false,
            url: '',
            req_cat_type: 'AbstractDataRequest'
        },
        initial_req: {
            timestamp_epoch_array: []
        },
        data_category_keys: {'req_cat_type': 'String', 'dataset': "String", 'grid': "Boolean"},
        no_data_accumulation: false,
        max_failure_attempts: 3,
        destroy_timer: 30000, // 30 seconds after completion
        retry_timer: 10000
    },
    request_active: false,
    request_processed: false,
    used_data_timeout: null,
    timeout_request: null,
    destroy_timeout: null,
    timestamp_added_timeout: null,
    req_activation_timeout: null,
    retry_init_timeout: null,
    metadata_set: false,
    data: {},
    init_data: null,
    used_data: [],
    data_store: {},
    timestamp_to_data: {},
    request_id: null,
    failure_count: 0,
    has_completed: false,
    has_data: false,
    initialize: function (op) {
        if (!op) {
            return this;
        }
        if (op.metadata && op.metadata.req_cat_type && op.metadata.req_cat_type !== this.options.metadata.req_cat_type) {
            if (OCS.Viewer.Classes[op.metadata.req_cat_type]) {
                return new OCS.Viewer.Classes[op.metadata.req_cat_type](op);
            } else {
                op.metadata.req_cat_type = this.options.metadata.req_cat_type;
            }
        }

        this.setOptions(op);
        if (this.is_valid()) {
            this.metadata_set = true;
        }
        this.init_events();
        var id = this.get_request_id();
        if (!OCS.Viewer.Live.DataRequest) {
            OCS.Viewer.Live.DataRequest = {};
        }
        OCS.Viewer.Live.DataRequest[id] = this;
        OCS.Viewer.Functions.init_utilities();

    },
    init_events: function () {
        this.addEvent('make_request_active', this.on_make_request_active.bind(this));
        this.addEvent('make_request_inactive', this.on_make_request_inactive.bind(this));
        this.addEvent('new_data_arrival', this.on_new_data_arrival.bind(this));
        this.addEvent('complete', this.on_completed.bind(this));
    },
    //
    // Event Fires
    //
    activate_request: function () {
        if (!this.request_active && this.is_valid()) {
            this.request_active = true;
            if (this.req_activation_timeout) {
                clearTimeout(this.req_activation_timeout);
                this.req_activation_timeout = null;
            }
            this.req_activation_timeout = setTimeout(function () {
                this.fireEvent('make_request_active', this);
            }.bind(this), 1);
            this.update_state(this.options.states.indexOf("Active - Waiting for data"));
        }
    },
    completed: function (force) {
        if (!this.has_completed) {
            if (this.is_request_completed() || force) {
                // We have no more intial data to retrieve
                this.has_completed = true;
                this.update_state(this.options.states.indexOf("Complete"));
                this.fireEvent('complete', this);
            }
        }
    },
    deactivate_request: function () {
        if (this.request_active) {
            if (this.req_activation_timeout) {
                clearTimeout(this.req_activation_timeout);
                this.req_activation_timeout = null;
            }
            this.req_activation_timeout = setTimeout(function () {
                this.fireEvent('make_request_inactive', this);
            }.bind(this), 1);
            this.request_active = false;
            this.update_state(this.options.states.indexOf("Inactive"));
        }
    },
    success: function () {
        this.fireEvent('success', this);
        this.completed();
        if (!this.has_completed && this.get_initial_req_timestamp_array().length) {
            if (this.retry_init_timeout) {
                clearTimeout(this.retry_init_timeout);
            }
            if (this.options.retry_timer && this.retries < this.options.max_failure_attempts) {
                this.retry_init_timeout = setTimeout(function () {
                    this.retry_init_timeout = null;
                    this.retries++;
                    this.fireEvent('process_again', this);
                }.bind(this), this.options.retry_timer);
            } else {
                // Giving up
                this.success_giveup();

            }
        }

    },
    success_giveup: function () {
        console.warn('OCS.Viewer.Classes.AbstractDataRequest: Not able to retrieve all the initial data!', this.options);
        this.destroy();
    },
    timestamp_added: function () {
        if (this.request_active && !this.timestamp_added_timeout) {
            this.timestamp_added_timeout = setTimeout(function () {
                this.timestamp_added_timeout = null;
                this.fireEvent('timestamp_added', this);
            }.bind(this), 0);
        }
    },

    //
    // Event Listeners
    //
    on_completed: function () {
        if (this.destroy_timeout) {
            clearTimeout(this.destroy_timeout);
        }
        if (this.options.destroy_timer) {
            this.destroy_timeout = setTimeout(function () {
                this.destroy_timeout = null;
                this.destroy();
            }.bind(this), this.options.destroy_timer);
        }
    },
    on_make_request_active: function () {
        // Method should be extended with code to make the request active by child classes
        if (this.timeout_request) {
            clearTimeout(this.timeout_request);
        }
        this.timeout_request = setTimeout(function () {
            this.timeout_request = null;
            this.fireEvent('request_active', this);
        }.bind(this), 0);
    },
    on_make_request_inactive: function () {
        // Method should be extended with code to make the request inactive by child classes
        if (this.timeout_request) {
            clearTimeout(this.timeout_request);
        }
        this.timeout_request = setTimeout(function () {
            this.timeout_request = null;
            this.fireEvent('request_inactive', this);
        }.bind(this), 0);
    },

    on_new_data_arrival: function (data) {
        // Determine if this data is relevent
        if (data && this.is_data_valid(data)) {
            // Its relevant
            this.set_data(data);
            this.update_state(this.options.states.indexOf("Active - Initial data recieved"));
            this.on_data_ready(data);
        }
    },
    on_data_ready: function (data) {
        var args = [this];
        if (data) {
            args.push(data);
            var timestamp_epoch = data.get_timestamp_epoch();
            if (timestamp_epoch) {
                args.push(timestamp_epoch);
            }
        }
        this.fireEvent('has_data', args);
        this.success();
    },

    //
    // Actions
    //
    add_timestamp_to_request: function (timestamp) {
        if (timestamp && !isNaN(parseFloat(timestamp)) && isFinite(timestamp)) {
            var init_length = this.options.initial_req.timestamp_epoch_array.length;
            this.options.initial_req.timestamp_epoch_array.combine([timestamp * 1]);
            if (init_length < this.options.initial_req.timestamp_epoch_array.length) {
                // Fire this event off if a timestamp was added
                this.timestamp_added();
            }
        }
    },
    add_variable: function (variable) {
        this.options.metadata.variables.push(variable);
    },
    clear_data: function () {
        this.data = {};
    },

    make_data_request_category_key: function () {
        var util = OCS.Viewer.Functions.get_utilities();
        return util.make_data_request_category_key(this.options.metadata, this.options.data_category_keys);
    },
//    /**
//     * Merge Request
//     * 
//     * Merge multiple request into 1
//     * 
//     * @param {type} req
//     * @returns {undefined}
//     */
//    merge_request: function (req) {
//        var metadata = req.get_metadata_clone();
//        var util = OCS.Viewer.Functions.get_utilities();
//        if (!this.metadata_set) {
//            this.options.metadata = util.clone_object(metadata);
//            this.metadata_set = true;
//        }
//
//        if (metadata.variables && metadata.variables.length) {
//            this.options.metadata.variables = util.array_combine_objects(this.options.metadata.variables, metadata.variables);
//        }
//        this.addEvent('success', req.success.bind(req));
//        this.merged_request.push(req);
//    },
    process_used_data: function () {
        this.used_data.each(this.remove_data.bind(this));
        this.used_data = [];
        this.clear_data();
        this.has_data = false;
        if (this.has_completed) {
            this.destroy();
        }

    },
    remove_data: function (data_id) {
        var data = this.data_store[data_id];
        delete this.data_store[data_id];
        var timestamp_epoch = data.get_timestamp_epoch();
        if (timestamp_epoch) {
            delete this.timestamp_to_data[timestamp_epoch];
        }
    },
    remove_timestamp_to_request: function (timestamp) {
        this.options.initial_req.timestamp_epoch_array.erase(timestamp);
    },

    unmake_data_request_category_key: function (category_key) {
        var util = OCS.Viewer.Functions.get_utilities();
        return util.unmake_data_request_category_key(category_key, this.options.data_category_keys);
    },
    update_state: function (state) {
        if (state > -1 && state < this.options.states.length && state !== this.state) {
            this.state = state;
            this.fireEvent('state_update', this.state);
        }
    },

    //
    // Booleans
    //
    has_variables_with_units: function (variables) {
        var i, variable;
        for (i = 0; i < variables.length; i++) {
            variable = variables[i];
            if (!this.has_variable_with_units(variable.parm, variable.units)) {
                return false;
            }
        }
        return true;
    },

    /**
     * 
     * @param {type} parm
     * @param {type} units
     * @returns {Boolean}
     */
    has_variable_with_units: function (parm, units) {
        var vars = this.get_variables();
        var i;
        for (i = 0; i < vars.length; i++) {
            if (vars[i].parm === parm) {
                if (!units || vars[i].units === units) {
                    return true;
                }
            }
        }
        return false;
    },
    has_url: function () {
        if (this.options.metadata.url !== "" && this.options.metadata.url !== null && this.options.metadata.url !== undefined) {
            return true;
        }
        return false;
    },
    is_data_valid: function (data) {
        var metadata = data.get_info();
        if (metadata.dataset === this.options.metadata.dataset) {
            return true;
        }
        return false;
    },
    is_gridded: function () {
        return this.options.metadata.grid;
    },
    is_completed: function () {
        return this.has_completed;
    },
    is_no_data_accumulation: function () {
        return this.options.no_data_accumulation;
    },
    is_request_completed: function () {
        if (this.has_data && !this.get_initial_req_timestamp_array().length) {
            return true;
        } else {
            return false;
        }
    },
    is_valid: function () {
        var ops = this.get_metadata();
        if (ops.dataset && (ops.variables.length || this.has_url()) && this.failure_count < this.options.max_failure_attempts) {
            return true;
        } else {
            return false;
        }
    },
    timestamp_requested: function (timestamp) {
        if (this.options.initial_req.timestamp_epoch_array.contains(timestamp * 1)) {
            return true;
        }
    },
    //
    // Getters / Setters
    //
    set_url: function (url) {
        this.options.metadata.url = url;
    },
    set_data: function (data) {
        this.has_data = true;
        this.data = data;
        if (data && data.get_id) {
            var data_id = data.get_id();
            this.data_store[data_id] = data;
            var timestamp_epoch = data.get_timestamp_epoch();
            if (timestamp_epoch) {
                this.timestamp_to_data[timestamp_epoch] = data_id;
                this.remove_timestamp_to_request(timestamp_epoch);

                this.used_data.combine([data_id]);
                this.set_used_data_timeout();
            }
        } else {
            this.set_used_data_timeout();
        }
    },
    set_num_request: function (num) {
        this.num_request = num;
    },
    get_data: function () {
        return this.data;
    },
    get_timestamp_to_data_keys: function () {
        return Object.keys(this.timestamp_to_data);
    },
    get_data_at_timestamp_epoch: function (timestamp_epoch) {
        if (timestamp_epoch) {
            if (this.timestamp_to_data[timestamp_epoch]) {
                var data_id = this.timestamp_to_data[timestamp_epoch];
                if (this.data_store[data_id]) {
                    this.used_data.combine([data_id]);
                    this.set_used_data_timeout();
                    return this.data_store[data_id];
                }
            }
            this.add_timestamp_to_request(timestamp_epoch);
        }
        return false;
    },
    get_first_data: function () {
        return this.data[0];
    },
    set_used_data_timeout: function () {
        if (!this.used_data_timeout) {
            this.used_data_timeout = setTimeout(function () {
                this.used_data_timeout = null;
                this.process_used_data();
            }.bind(this), 5000);
        }
    },
    get_variables: function () {
        return this.options.metadata.variables;
    },
    set_variables: function (vars) {
        this.options.metadata.variables = vars;
    },
    get_url: function () {
        return this.options.metadata.url;
    },
    get_data_manager: function () {

    },
    get_data_category_keys: function () {
        return this.options.data_category_keys;
    },
    get_dataset: function () {
        return this.options.metadata.dataset;
    },
    get_req_cat_type: function () {
        return this.options.metadata.req_cat_type;
    },
    get_request_id: function () {
        if (!this.request_id) {
            this.request_id = this.class_type + "-" + this.class_name + "=" + this.create_unique_id();
        }
        return this.request_id;
    },
    get_subscription: function () {
        return false;
    },

    metadata: function () {
        return this.get_metadata();
    },
    get_metadata: function () {
        return this.options.metadata;
    },
    get_metadata_clone: function () {
        var util = OCS.Viewer.Functions.get_utilities();
        return util.clone_object(this.options.metadata);
    },
    get_initial_req_timestamp_array: function () {
        return this.options.initial_req.timestamp_epoch_array;
    },
    get_initial_req_timestamp_item: function () {
        if (this.options.initial_req.timestamp_epoch_array.length) {
            return this.options.initial_req.timestamp_epoch_array[0];
        }
    },

    //
    // Destroy method
    //
    destroy: function () {
        if (this.destroy_timeout) {
            clearTimeout(this.destroy_timeout);
        }
        if (this.timeout_request) {
            clearTimeout(this.timeout_request);
            this.timeout_request = null;
        }
        if (this.timestamp_added_timeout) {
            clearTimeout(this.timestamp_added_timeout);
            this.timestamp_added_timeout = null;
        }
        if (this.retry_init_timeout) {
            clearTimeout(this.retry_init_timeout);
        }
        if (this.req_activation_timeout) {
            clearTimeout(this.req_activation_timeout);
            this.req_activation_timeout = null;
        }
        if (this.request_id) {
            delete OCS.Viewer.Live.DataRequest[this.request_id];
        }
        this.completed(true);
        if (this.destroy_timeout) {
            clearTimeout(this.destroy_timeout);
        }
        this.used_data = [];
        this.clear_data();
        this.has_data = false;
        this.request_processed = false;
        this.request_id = null;
        this.merged_request = [];
        this.data = {};
        this.data_store = {};
        this.timestamp_to_data = {};
        this.init_data = null;
        this.failure_count = 0;
        this.setOptions({
            states: ["Inactive", "Active - Waiting for data", "Active - Initial data recieved", "Complete"],
            metadata: {
                dataset: '',
                variables: [],
                grid: false,
                url: '',
                req_cat_type: 'AbstractDataRequest'
            },
            initial_req: {
                timestamp_epoch_array: []
            },
            data_category_keys: {'req_cat_type': 'String', 'dataset': "String", 'grid': "Boolean"},
            no_data_accumulation: false,
            max_failure_attempts: 3
        });
        this.fireEvent('request_destroyed', this);
        this.removeEvents();
        this.$events = {};
    }
});